import { useReducer } from 'react';

export const useForceUpdate = () => {
    const [updateTrigger, forceUpdate] = useReducer((x) => x + 1, 0);
    return { updateTrigger, forceUpdate };
};
